var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26575(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26575",
    "data-name": "Group 26575",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11991",
    "data-name": "Rectangle 11991",
    width: 40,
    height: 40,
    fill: "#1a1a1a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26574",
    "data-name": "Group 26574",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23140",
    "data-name": "Path 23140",
    d: "M40,38.125A1.869,1.869,0,0,1,38.125,40H1.875A1.869,1.869,0,0,1,0,38.125V29.376A1.869,1.869,0,0,1,1.875,27.5H13.336l3.828,3.828a4.006,4.006,0,0,0,5.672,0L26.664,27.5H38.125A1.869,1.869,0,0,1,40,29.376ZM23.125,0A1.87,1.87,0,0,1,25,1.875V15h6.852a1.56,1.56,0,0,1,1.1,2.664L21.07,29.555a1.514,1.514,0,0,1-2.133,0L7.039,17.664A1.56,1.56,0,0,1,8.141,15H15V1.875A1.87,1.87,0,0,1,16.875,0ZM28.75,34.688a1.563,1.563,0,1,0,1.562,1.562,1.567,1.567,0,0,0-1.562-1.562m5,0a1.563,1.563,0,1,0,1.562,1.562,1.567,1.567,0,0,0-1.562-1.562",
    fill: "#1a1a1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26575);
export default __webpack_public_path__ + "static/media/Group 26575.ec3dc3e7af222dc9b5584220d2b13ff6.svg";
export { ForwardRef as ReactComponent };